import NotificationItem from './NotificationListItem'
import { useSelector } from 'react-redux'

const NotificationList = ({setShowModal, setDeleteModal, isRecurring}) => {
  const { scheduled } = useSelector((state) => state.notification)

  return (
    <>
      {scheduled?.data?.map((n, index) => (
        <NotificationItem
          item={n}
          setModalData={setShowModal}
          setDeleteModal={setDeleteModal}
          key={`${n.id}-${index}`}
          isRecurring={isRecurring}
        />
      ))}
    </>
  )
}

export default NotificationList
